import objectAssign from 'object-assign';

const isLogTypePrevented = (action) => {
  switch(action.type) {
    case 'COUNT_DOWN_UPDATE':
    case 'ELAPSED_SECONDS_UPDATE':
    case 'STATUS_UPDATE':
    case 'LANGUAGE_UPDATE':
    case 'GPIO_READ_UPDATE':
    case 'PAD_INPUT_CHECKBOX_UNCHECKED':
    case 'PAD_INPUT_CHECKBOX_CHECKED':
    case 'GPIO_READ_UPDATE':
    case 'VARIABLE_UPDATE':
    case 'SFX_ENDED':
    case 'PUSH_STAGE':
      return true;
    default:
      return false;
  }
}
export const logger = store => next => action => {
  // return next(action);  // Comment to show log

  // Show Client Only
  if(typeof action.meta !== 'undefined'
    && action.meta.context == 'SERVER') {
    return next(action);
  }

  if((typeof action.meta === 'object' 
    && action.meta.log === false)
    || isLogTypePrevented(action))
    return next(action);


	console.group(action.type)
	console.info('Dispatching', action)
	let result = next(action)
	console.log('Next state', store.getState())
	console.groupEnd(action.type)
	return result
}


export const createBroadcastIo = io => store => next => action => {
  	if (action.meta && action.meta.sendClient) {
    	io.sockets.emit('action', {...action, meta: {...action.meta, sendServer: false}});
    	// console.log('send clients '+JSON.stringify(action))
  	}
  	return next(action);
}

export const addServerContext = store => next => action => {
    return next({...action, meta: {...(action.meta), context: 'SERVER'}});
}

/* // Todo
export const createPersistance = database => store => next => action => {
	if (action.meta && action.meta.persist) {
		database.saveState(store.getState());
	}
}
*/

// For The Client:
// This middleware will just add the property "async dispatch"
// to actions with the "async" property set to true
export const asyncDispatchMiddleware = store => next => action => {
  let syncActivityFinished = false;
  let actionQueue = [];

  function flushQueue() {
    actionQueue.forEach(a => store.dispatch(a)); // flush queue
    actionQueue = [];
  }

  function asyncDispatch(asyncAction) {
    actionQueue = actionQueue.concat([asyncAction]);

    if (syncActivityFinished) {
      flushQueue();
    }
  }

  const actionWithAsyncDispatch =
    Object.assign({}, action, { asyncDispatch });

  next(actionWithAsyncDispatch);
  syncActivityFinished = true;
  flushQueue();
};

// This middleware will just add the property "async dispatch"
// to actions with the "async" propperty set to true on the server side.
// It filters only the actions with the meta asyncServer = true
export const asyncDispatchServerMiddleware = store => next => action => {
  let syncActivityFinished = false;
  let actionQueue = [];

  function flushQueue() {
    actionQueue.forEach(a => store.dispatch(a)); // flush queue
    actionQueue = [];
  }

  function asyncDispatch(asyncAction) {
  	if(!asyncAction.meta?.asyncServer)
  		return;

    actionQueue = actionQueue.concat([asyncAction]);

    if (syncActivityFinished) {
      flushQueue();
    }
  }

  const actionWithAsyncDispatch =
    Object.assign({}, action, { asyncDispatch });

  next(actionWithAsyncDispatch);
  syncActivityFinished = true;
  flushQueue();
};

export function createBridgeEventManager(eventManager, eventName = 'action') {
  const emitBound = eventManager.emit.bind(eventManager);
  return ({ dispatch }) => {
    // Wire eventManager to dispatch actions sent by the eventManager.
    eventManager.on(eventName, data => {
      if(!data.meta?.alreadyEventManaged)
        dispatch(data);
    });
    
    return next => (action) => {
      if(!action.meta?.alreadyEventManaged)
        return defaultExecute(action, emitBound, next, dispatch);
      return next(action);
    };
  };

  function defaultExecute(action, emit, next, dispatch) { // eslint-disable-line no-unused-vars
    action.meta = {...action.meta, alreadyEventManaged: true};
    emit(eventName, action);
    return next(action);
  }
}